import { IQuestionAnswer } from "app/components/composites/Category/QnACategory";
import CollapsibleOverview, { IToggleTerms } from "app/components/composites/CollapsibleOverview";
import Sidebox from "app/components/composites/Sidebox";
import Segment from "app/components/page/Segment";
import { Grid } from "semantic-ui-react";
import "./styles.scss";

interface IProps {
	questionAndAnswers: IQuestionAnswer[];
	title: string | JSX.Element;
	description: string | JSX.Element;
	sideboxText: string[];
	otherTerms: IToggleTerms;
}

const Overview = (props: IProps): JSX.Element => {
	return (
		<Segment paddingBottom={104}>
			<Grid>
				<Grid.Row>
					<Grid.Column className="no-padding-vertical no-margin" mobile={12} tablet={12} computer={8}>
						<h1 className="overview__title" id="page-title">
							{props.title}
						</h1>
						{props.description}
					</Grid.Column>
				</Grid.Row>

				<Grid.Row className="overview__content">
					<Grid.Column mobile={12} tablet={12} computer={8} className="no-padding-top-bottom no-margin">
						<CollapsibleOverview content={props.questionAndAnswers} otherTerms={props.otherTerms} />
					</Grid.Column>

					<Grid.Column className="no-margin no-padding" floated="right" mobile={12} tablet={12} computer={4}>
						<Sidebox text={props.sideboxText[0]} link={[props.sideboxText[1], "/find-a-service"]} />
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</Segment>
	);
};

export default Overview;
